import Swiper, { Scrollbar } from "swiper";

export default () => ({
  height: null,
  swiper: null,
  isSlider: null,
  multipleMedia: null,
  rowIndex: null,
  rowIndexMobile: null,
  fullWidth: null,
  vertAlignment: null,

  setIsSlider(size) {
    this.isSlider = window.innerWidth < 1024 && size > 1;
  },

  initSlider() {
    this.swiper = new Swiper(this.$refs.slider, {
      cssMode: true,
      modules: [Scrollbar],
      preloadImages: false,
      slidesPerView: 1.2,
      spaceBetween: 0,
      scrollbar: {
        el: ".swiper-scrollbar",
      },
    });
  },

  updateStickyDivHeight() {
    if (window.innerWidth > 768) {
      const textWrapperHeight = this.$refs.textWrapper
        ? this.$refs.textWrapper.clientHeight
        : 0;
      this.$refs.stickyDiv.style.height = `calc(100% - ${textWrapperHeight}px)`;
    }
  },

  initHeightFullWidth() {
    if (window.innerWidth > 768) {
      this.$refs.wrapper.style.height = `${window.innerHeight - 54}px`;
      this.updateStickyDivHeight();
    }
  },

  initHeightTwoRows(fullWidthOverride) {
    if (window.innerWidth > 768) {
      if (fullWidthOverride) {
        this.initHeightFullWidth();
      } else {
        this.updateStickyDivHeight();
        this.$refs.wrapper.style.height = `calc(100% - 54px)`;
      }
    }
  },

  initHeight() {
    const textWrapperHeight = this.$refs.textWrapper
      ? this.$refs.textWrapper.clientHeight
      : 0;
    this.$refs.stickyDiv.style.height = `calc(100% - ${textWrapperHeight}px)`;
    this.$refs.wrapper.style.height = `calc(100% - ${textWrapperHeight}px)`;
  },

  setOrder(size) {
    let classes = this.$refs.wrapper.parentElement.className.split(" ");

    if (window.innerWidth < 768) {
      this.setMobileModuleGridSize(size, classes);
    } else {
      if (this.fullWidth) {
        this.setModuleGridSize(size, false, classes);
      } else {
        if (this.multipleMedia) {
          this.setModuleGridSize(size, false, classes);
        } else {
          this.setModuleGridSize(size, true, classes);
        }
      }
    }
  },

  setMobileModuleGridSize(size, classes) {
    let listParent = this.$refs.wrapper.parentElement;

    if (size === "product-grid-8") {
      listParent.classList.add("hidden");
      return;
    }

    if (size === "product-grid-small") {
      listParent.classList.remove("col-span-2");
      this.setNewOrder(classes, 1, false, false);
    } else {
      if (!listParent.classList.contains("col-span-2")) {
        listParent.classList.add("col-span-2");
        this.setNewOrder(classes, 2, false, false);
      }
    }
  },

  setModuleGridSize(size, isTwoRowModule, classes) {
    let listParent = this.$refs.wrapper.parentElement;

    if (size === "product-grid-8") {
      listParent.classList.add("hidden");
      return;
    }

    if (size === "product-grid-small") {
      if (isTwoRowModule) {
        listParent.classList.remove("lg:row-span-2", "col-span-2");
        listParent.classList.add("hidden");
        this.initHeightFullWidth();
        this.setNewOrder(classes, 3, true);
      } else {
        this.setNewOrder(classes, 3);
      }
    } else {
      if (isTwoRowModule) {
        listParent.classList.remove("hidden");
        listParent.classList.add("lg:row-span-2", "col-span-2");
        this.initHeightTwoRows();
        this.setNewOrder(classes, 4, true, true);
      } else {
        this.setNewOrder(classes, 4);
      }
    }
  },

  setNewOrder(classes, cols, twoCol, twoRowOffset) {
    let orderDesk = classes.find((str) => str.startsWith("order-"));
    let orderMobile = classes.find((str) => str.startsWith("max-lg:order-"));
    let order = window.innerWidth < 768 ? orderMobile : orderDesk;

    let regex = /\[(\d+)\]/;
    let match = order.match(regex);

    if (match) {
      let newNumber = twoCol
        ? (this.rowIndex - 1) * cols +
          (this.vertAlignment === "center"
            ? 1
            : this.vertAlignment === "right"
            ? 2
            : 0)
        : (this.rowIndex - 1) * cols;

      let newOrder = order.replace(regex, `[${newNumber}]`);
      this.$refs.wrapper.parentElement.classList.remove(order);
      this.$refs.wrapper.parentElement.classList.add(newOrder);
    }
  },
});
